/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const defaultVideoPoster = {
  src: '/images/video-default-poster-gray.svg',
  alt: 'defaultVideoPoster',
};
